// src/lib/onboarding-b-variant.ts
// Puro e tsc-verificável: normaliza a flag do A/B e decide o destino do redirect.

export const ONBOARDING_VARIANT_FLAG = "onboarding_variant" as const;
export const ONBOARDING_VARIANT_STORAGE_KEY = "gamefik_onboarding_variant" as const;
export const ONBOARDING_A_PATH = "/signup/teacher-onboarding" as const;
export const ONBOARDING_B_PATH = "/signup/teacher-onboarding-b" as const;

export type OnboardingVariant = "control" | "educativo";

/** Qualquer coisa diferente de "educativo" cai em "control" (fallback seguro = A). */
export function normalizeVariant(value: string | boolean | undefined): OnboardingVariant {
  return value === "educativo" ? "educativo" : "control";
}

/** Destino do redirect do professor. null = não decidir ainda (variante não resolvida). */
export function onboardingRedirectTarget(variant: OnboardingVariant | null): string | null {
  if (variant === null) return null;
  return variant === "educativo" ? ONBOARDING_B_PATH : ONBOARDING_A_PATH;
}
